import FeatureFeedbackAPI, {
  type FeatureFeedbackPayload,
} from 'api/feature-feedback.api';
import { BaseHandler } from './base.handler';

export default class FeatureFeedbackHandler extends BaseHandler {
  private readonly api: FeatureFeedbackAPI;

  constructor() {
    super();
    this.api = new FeatureFeedbackAPI();
  }

  async submitFeedback(payload: FeatureFeedbackPayload): Promise<void> {
    try {
      await this.api.postFeedback(payload);
    } catch (error: any) {
      // feedback is non-critical — fail silently
    }
  }
}
